import React from "react";
import { SectionArticle } from "../../shared/ArticleTemplate";

const Celebrations = ({parentPath}) => 
  <SectionArticle sectionName="local_celebrations" backRoute={parentPath}/>

export default Celebrations;